import React, { useEffect, useState } from "react";
import MainLayout from "../components/Layout/MainLayout";
import { Button, Dropdown, Space, Breadcrumb, message } from "antd";
import SearchInput from "../components/Forms/SearchInput";
import { FaCaretDown } from "react-icons/fa";
import { useNavigate, useSearchParams, Link, useOutletContext } from "react-router-dom";
import FileUploadModal from "../components/models/FileUploadModal";
import { postApi } from "../services/api";
import { items, roleIds } from "../constant";
import { FiEdit2 } from "react-icons/fi";
import { useSelector } from "react-redux";
import DragDropTable from "../components/Tables/DragDropTable";
import { useGlobalModal } from "../context/SuccessModalProvider";
import Loader from "../common/Loader";
import ProductImageName from "../components/Layout/ProductImageName";
import { calcInStock, handleRouteNav } from "../utils";
import CustomBadge from "../components/Charts/CustomBadge";
import { ProductMorePagesButtons } from "./Products";

const ProductNewlyAdded = () => {
  const { showPopup } = useGlobalModal();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const { user_id, full_name, is_admin, is_sales_manager, role_id } = useSelector(
    (state) => state.auth,
  );
  const [productData, setProductData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get("q") || "";
  const [loading, setLoading] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false); // track image load

  const onSearch = (value, _e, info) =>
    console.log(info === null || info === void 0 ? void 0 : info.source, value);

  const handleOnSearchChange = (e) => {
    const value = e.target.value;
    setSearchParams(
      (prev) => {
        if (value) prev.set("q", value);
        else prev.delete("q");
        return prev;
      },
      { replace: true },
    );
  };

  const handleMenuClick = (e) => {
    console.log("click", e);
  };

  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const fetchProducts = async () => {
    try {
      setLoading(true); // start loader

      const response = await postApi("sales/product/newly/list", {
        search: query,
      });
      const formattedRows = (response.data || []).map((item, idx) => ({
        ...item,
        id: item.id ?? item.product?.id ?? idx, // stable identifier
        key: item.id ?? item.product?.id ?? idx,
        productImageUrl: item.product?.product_pic_url,
      }));
      setProductData(formattedRows);
    } catch (error) {
      console.error("Error fetching products:", error);
    } finally {
      setLoading(false); // stop loader
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProducts();
    }, 300);

    return () => clearTimeout(handler);
  }, [query]);

  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  const columns = [
    // {
    //   title: "Product",
    //   dataIndex: "product",
    //   key: "product",
    //   sorter: (a, b) => a.short_name.localeCompare(b.short_name),
    //   render: (item, row) => (
    //     <div className="flex items-center gap-4">
    //       <div className="relative group w-14 h-14">
    //         <img
    //           src={item?.product_pic_url}
    //           alt={row.short_name}
    //           className="w-full h-full object-cover rounded"
    //         />
    //         <div
    //           className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
    //           // onClick={() => setIsModalOpen(true)}
    //         >
    //           <FiEdit2 style={{ color: "#fff", fontSize: 16 }} />
    //         </div>
    //       </div>
    //       <div>
    //         <div className="font-semibold">{row?.short_name}</div>
    //         <div className="text-xs text-gray-500">{row?.clienttype}</div>
    //       </div>
    //     </div>
    //   ),
    //   ellipsis: true,
    //   width: 200,
    // },
    {
      title: "Product",
      dataIndex: "product",
      key: "product",
      render: (item, row) => {
        return (
          <ProductImageName
            img_url={item?.product_pic_url}
            img_alt={row?.short_name}
            text={
              <div>
                <div className="font-semibold">{row?.short_name}</div>
                <div className="text-xs text-gray-500">{row?.clienttype}</div>
              </div>
            }
          />
        );
      },
      ellipsis: true,
      width: 200,
    },
    // {
    //   title: "Price",
    //   dataIndex: "rate",
    //   key: "rate",
    //   render: (value) => `₹${value} / meter`,
    //   ellipsis: true,
    //   width: 100,
    // },
    {
      title: "Availability",
      dataIndex: "quality_code",
      key: "quality_code",
      render: (_, item) => {
        const isInStock = calcInStock(
          item.quality_shade?.bsr_stock_cases,
          item.quality_shade?.dcl_stockmtrs,
        );

        return (
          <div className="w-full flex items-center px-2 py-2">
            {isInStock ? (
              <CustomBadge variant="success" text="In Stock" />
            ) : (
              <CustomBadge variant="pending" text="Make to order" />
            )}
          </div>
        );
      },
      ellipsis: true,
      width: 140,
    },
    {
      title: "Width",
      dataIndex: "finish_width",
      key: "finish_width",
      render: (value) => `${Number(value)}''`,
      ellipsis: true,
      width: 80,
    },
  ];

  const handleRowClick = (record) => {
    navigate(handleRouteNav(`/product-details/${record.sort_no}`, role_id));
  };

  const { setTitle, setDescription, setBackButton } = useOutletContext();

  useEffect(() => {
    setTitle("Now Trending Products");
    setDescription(
      <div>
        <Breadcrumb>
          {[
            { title: "Home", href: handleRouteNav("/dashboard", role_id) },
            { title: "Product Catalogue ", href: handleRouteNav("/product-catalog", role_id) },
            {
              title: "Now Trending Products",
              href: handleRouteNav("/product-catalog/now-trending", role_id),
            },
          ].map((item, index) => (
            <Breadcrumb.Item key={index}>
              <Link to={item.href}>{item.title}</Link>
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      </div>,
    );
    setBackButton(true);
  }, [setTitle, setDescription, setBackButton]);

  return (
    <>
      <>
        <ProductMorePagesButtons activeButton={"now-trending"} role_id={role_id} />

        <div className="bg-[#FFFFFF]" style={{ borderRadius: "32px", overflow: "hidden" }}>
          {loading ? (
            <div className="flex justify-center items-center py-20">
              <Loader size={60} />{" "}
            </div>
          ) : (
            <DragDropTable
              columns={columns}
              data={productData}
              handleRow={handleRowClick}
              onSave={async (payload) => {
                console.log("Payload for API:", payload);

                try {
                  // 1. Process deletions
                  if (payload.deletions?.length > 0) {
                    await Promise.all(
                      payload.deletions.map((item) =>
                        postApi("sales/product/add-is-newly", {
                          updated_by: full_name,
                          updated_by_id: user_id,
                          sort_no: item.sort_no,
                          quality_code: item.quality_code,
                          is_newly: 0,
                        }),
                      ),
                    );
                  }

                  // 2. Process reordering (only if needed)
                  if (payload.order?.length > 0) {
                    const response = await postApi("sales/product/rearrange-newly", {
                      order: payload.order,
                    });

                    if (!response?.status) throw new Error(response?.message);

                    showPopup({
                      title: null,
                      content: <span className="custom-modal-title">{response.message}</span>,
                      onOk: () => console.log("Confirmed!"),
                      className: "custom-success-modal",
                    });
                  }

                  // 3. Refresh products
                  fetchProducts();
                } catch (error) {
                  console.error("Upload failed:", error.response?.data || error.message);
                  showPopup({
                    title: "Error",
                    content: (
                      <span className="custom-modal-title">
                        {error.response?.data?.message || "Something went wrong"}
                      </span>
                    ),
                    className: "custom-error-modal",
                  });
                }
              }}
              dragAfterKey="product"
              hideActions={!is_sales_manager && !is_admin}
            />
          )}
        </div>
      </>
    </>
  );
};

export default ProductNewlyAdded;
